<template>
  <div class="panel-body">
    <h4>Billing History</h4>

    <template v-if="$user.isSme() && invoices.length !== 0">
      <div class="row" style="margin-top: 25px">
        <div class="col-xs-12">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <th width="25%">Date</th>
              <th width="20%" class="text-center">Status</th>
              <th width="35%" class="text-center">Amount</th>
              <th width="30%" class="text-right">Download</th>
              </thead>
              <tbody>
              <tr v-for="(invoice, key) in invoices" :key="key">
                <td>{{invoice.created | moment('LL')}}</td>
                <td class="text-center">{{invoice.status}}</td>
                <td class="text-center">{{(parseFloat(invoice.total) / 100) | toCurrency}}</td>
                <td class="text-right"><a target="_blank" class="btn btn-info btn-xs" :href="invoice.invoice_pdf">Receipt</a></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-xs-12">
          Account Balance: {{Math.abs(balance) / 100 | toCurrency}}
        </div>

        <div class="col-xs-12" style="margin-top: 20px" v-if="!$user.isBasic()">
          <div class="checkbox checkbox-info checkbox-inline">
            <input type="checkbox" v-model="autoRenewal" id="autoRenewal" @change="updateAutoRenewal">
            <label style="color:black" for="autoRenewal">Automatic subscription renewal</label>
            <span v-if="cancelAt !== null">(your subscription is enabled until {{cancelAt | moment('LL')}})</span>
          </div>
        </div>

        <div class="col-xs-12" style="margin-top: 20px" v-if="!$user.isBasic()">
          You can cancel your subscription at any time by switching to a Basic plan (<router-link :to="{name: 'Plans'}">Subscriptions plans menu</router-link>)
        </div>

      </div>
      <div class="row" style="margin-top: 25px" v-if="$user.isSme()">
        <div class="col-xs-12">
          <span class="small">For more information on pricing, visit <router-link :to="{name: 'Plans'}">our Pricing page</router-link></span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row" style="margin-top: 25px">
        <div class="col-xs-12 text-center">
          <a href="mailto:support-idexlab@group-gac.com" class="btn btn-info">Contact Support</a>
        </div>
      </div>
    </template>

  </div>
</template>

<script>

export default {
  name: 'Bills',
  props: [],
  data () {
    return {
      invoices: [],
      currentPlan: null,
      balance: 0,
      autoRenewal: null,
      cancelAt: null
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('payment/plan').then((response) => {
        this.currentPlan = response.data
      })

      this.axios.get('payment/endSubscription').then((response) => {
        if (response.data !== null) {
          this.autoRenewal = !response.data.cancel_at_period_end
          this.cancelAt = response.data.cancel_at
        }
      })

      this.axios.get('payment/invoices').then((response) => {
        this.invoices = response.data.invoices
        this.balance = response.data.balance
      })
    },
    updateAutoRenewal: function () {
      if (this.autoRenewal !== null) {
        this.axios.post('payment/endSubscription', {auto_renewal: this.autoRenewal}).then((response) => {
          if (response.data !== null) {
            this.autoRenewal = !response.data.cancel_at_period_end
            this.cancelAt = response.data.cancel_at
          }

          let title
          if (this.cancelAt === null) {
            title = 'The automatic subscription renewal has been activated'
          } else {
            title = 'The automatic subscription renewal has been deactivated'
          }

          this.$notify({
            type: 'success',
            title: title,
            content: '',
            placement: 'bottom-right'
          })
        })
      }
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Bills.vue